<template>
  <div class="canvas-settings fade-in">
    <div class="panel">
      <h1>Settings</h1>
      <span class="round-button close-button" @click="close">X</span>
      <div class="content">
        <h2>User</h2>
        <div class="field">
          <div class="label">
            Name:
          </div>
          <input type="text" v-model="userName" placeholder="username..." @blur="changeUserName">
        </div>
        <h2>Background</h2>
        <div class="field">
          <div class="label">
            Colour:
          </div>
          <input class="choose-colour" type="color" v-model="settings.background.colour" @blur="update">
        </div>

        <div class="field">
          <div class="label">
            Custom styling:
          </div>
          <textarea cols="20" rows="5" class="custom-styling" v-model="oldSettings.background.customStyling" @blur="updateCustomStyling" placeholder="background: url( '/some-image.png' );"></textarea>
        </div>

        <!-- <div class="field">
          <div class="label">
            Global styling:
          </div>
          <textarea cols="20" rows="5" class="custom-styling" v-model="oldSettings.background.globalStyling" @blur="updateGlobalStyling" placeholder="@keyframe fade-in { }"></textarea>
        </div> -->

      </div>
    </div>
  </div>
</template>

<script>

import _ from 'lodash';

export default {
  props: {
    settings: {
      type: Object,
      required: true,
      validator: (settings) => Object.keys(settings).includes('background')
    }
  },
  data() {
    return {
      oldSettings: {},
      userName: localStorage.getItem('userName')
    }
  },
  methods: {
    close() {
      this.$parent.showBoardSettings = false;
    },
    updateCustomStyling() {
      this.settings.background.customStyling = this.oldSettings.background.customStyling;

      this.update();
    },
    updateGlobalStyling() {
      this.settings.background.globalStyling = this.oldSettings.background.globalStyling;

      this.update();
    },
    update() {
      this.connection.emit('settings_update', this.settings)
    },
    changeUserName() {
      if (this.userName === '') return;

      localStorage.setItem('userName', this.userName);
      this.$parent.userName = this.userName;
    }
  },
  created() {
    this.oldSettings = _.cloneDeep(this.settings);
  }
}
</script>

<style scoped>

.canvas-settings {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  display: flex;
  justify-content: center;
  align-items: center;
}

.panel {
  z-index: 2;
  background-color: white;
}

.choose-colour {
  width: 30%;
}

.close-button {
  position: absolute;
  right: 10px;
  top: 10px;
  color: white;

  background-color: rgb(182, 1, 1);
}

.close-button:hover {
  background-color: rgb(109, 0, 0);
}

.panel {
  position: relative;
}

.custom-styling {
  font-family: 'Roboto Mono', monospace;
  resize: none;
  width: 50%;
}

.field {
  margin: 10px 0;
}

</style>



// WEBPACK FOOTER //
// src/components/CanvasSettings.vue